<template>
  <el-dialog
    width="800px"
    title="自定义订单报表导出"
    v-model="isvisible"
    v-if="isvisible"
    class="exportBox"
  >
    <div>
      <el-form
        ref="exportFormRef"
        :model="exportForm"
        label-width="120px"
        class="demo-ruleForm"
        status-icon
      >
        <el-checkbox-group v-model="exportForm.header">
          <h1>订单基本信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="platformed" label="0||platformed||平台交易时间"
                >平台交易时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="created" label="0||created||垚旌导入时间"
                >垚旌导入时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="platformnum" label="0||platformnum||平台订单号"
                >平台订单号</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="ordernum" label="0||ordernum||垚旌订单号"
                >垚旌订单号</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="ordertype" label="0||ordertype||订单类型"
                >订单类型</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="orderstatus" label="0||orderstatus||订单状态"
                >订单状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="receiver" label="0||receiver||收货人姓名"
                >收货人姓名</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="receiverphone"
                label="0||receiverphone||收货人电话"
                >收货人电话</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="receiveraddress"
                label="0||receiveraddress||收货地址"
                >收货地址</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="completed" label="0||completed||订单完成时间"
                >订单完成时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="ordernote" label="0||ordernote||客户下单备注"
                >客户下单备注</el-checkbox
              >
            </li>
          </ul>
          <h1>订单金额信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="saleamount" label="1||saleamount||销售金额"
                >销售金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="costamount" label="1||costamount||成本金额"
                >成本金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="maolieamount" label="1||maolieamount||毛利额"
                >毛利额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="maoliv" label="1||maoliv||毛利率"
                >毛利率</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="maolivstatus"
                label="1||maolivstatus||毛利率状态"
                >毛利率状态</el-checkbox
              >
            </li>
          </ul>
          <h1>订单商品信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="goodsnum" label="2||goodsnum||商品ID"
                >商品ID</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="name" label="2||name||商品名称"
                >商品名称</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="catalogname" label="2||catalogname||商品类目"
                >商品类目</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="brandname" label="2||brandname||商品品牌"
                >商品品牌</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="specification"
                label="2||specification||商品规格"
                >商品规格</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="costprice" label="2||costprice||成本价"
                >成本价</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="marketprice" label="2||marketprice||市场价"
                >市场价</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="discount" label="2||discount||商品折扣"
                >商品折扣</el-checkbox
              >
            </li>
          </ul>
          <h1>订单发货信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="expressnum" label="3||expressnum||快递单号"
                >快递单号</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="expresscompany"
                label="3||expresscompany||快递公司"
                >快递公司</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="deliveryed" label="3||deliveryed||发货时间"
                >发货时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="freightamount"
                label="3||freightamount||运费金额"
                >运费金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="deliverynote" label="3||deliverynote||后端处理备注"
                >后端处理备注</el-checkbox
              >
            </li>
          </ul>
          <h1>订单售后信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="applyed" label="4||applyed||申请时间"
                >申请时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="saletype" label="4||saletype||售后类型"
                >售后类型</el-checkbox
              >
            </li>
            <li style="display:none">
              <el-checkbox :checked="true" name="reason" label="4||reason||申请原因"
                >申请原因</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="salecompleted"
                label="4||salecompleted||售后完成时间"
                >售后完成时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="salestatus" label="4||salestatus||售后状态"
                >售后状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="supplieramount"
                label="4||supplieramount||供应商货款事宜"
                >供应商货款事宜</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="salenote" label="4||salenote||售后说明"
                >售后说明</el-checkbox
              >
            </li>
          </ul>

          <h1>客户信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="name" label="5||customername||客户"
                >客户</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="paidway" label="5||paidway||收款方式"
                >收款方式</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="cuspaidamount"
                label="5||cuspaidamount||收款金额"
                >收款金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="paidaccount" label="5||paidaccount||收款账户"
                >收款账户</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="iscontract" label="5||ciscontract||有无合同"
                >有无合同</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="isaccount" label="5||cisaccount||有无账期"
                >有无账期</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cuspaided" label="5||cuspaided||客户对账时间"
                >客户对账时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cusistax" label="5||cusistax||有无开票"
                >有无开票</el-checkbox
              >
            </li>
            <!-- <li>
              <el-checkbox :checked="true" name="custaxtype" label="5||custaxtype||发票类型"
                >发票类型</el-checkbox
              >
            </li> -->
            <li>
              <el-checkbox :checked="true" name="taxpoint" label="5||ctaxpoint||开票税点"
                >开票税点</el-checkbox
              >
            </li>
          </ul>
          <h1>供应商信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="name" label="6||suppliername||供应商"
                >供应商</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="payway" label="6||payway||付款方式"
                >付款方式</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppayamount" label="6||suppayamount||付款金额"
                >付款金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="payaccount" label="6||payaccount||付款账户"
                >付款账户</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="iscontract" label="6||siscontract||有无合同"
                >有无合同</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="isaccount" label="6||isaccount||有无账期"
                >有无账期</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppayed" label="6||suppayed||供应商对账时间"
                >供应商对账时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="supistax" label="6||supistax||有无开票"
                >有无开票</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suptaxtype" label="6||suptaxtype||发票类型"
                >发票类型</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="taxpoint" label="6||staxpoint||开票税点"
                >开票税点</el-checkbox
              >
            </li>
          </ul>
          <h1>客户对账信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="cusstatus" label="7||cusstatus||客户对账状态"
                >客户对账状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cuspaided" label="7||cuspaided||客户对账时间"
                >客户对账时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="cuscompensation"
                label="7||cuscompensation||差异补偿金额"
                >差异补偿金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="cussetstatus"
                label="7||cussetstatus||客户结算状态"
                >客户结算状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="cuspaidamount"
                label="7||cuspaidamount||应收金额"
                >应收金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cusistax" label="7||cusistax||收款开票"
                >收款开票</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cusnote" label="7||cusnote||客户对账备注"
                >客户对账备注</el-checkbox
              >
            </li>
          </ul>
          <h1>供应商对账信息</h1>
          <ul>
            <li>
              <el-checkbox :checked="true" name="supstatus" label="8||supstatus||供应商对账状态"
                >供应商对账状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppayed" label="8||suppayed||供应商对账时间"
                >供应商对账时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="supcompensation"
                label="8||supcompensation||差异补偿金额"
                >差异补偿金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="supsetstatus"
                label="8||supsetstatus||供应商结算状态"
                >供应商结算状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppayamount" label="8||suppayamount||应付金额"
                >应付金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="supistax" label="8||supistax||付款开票"
                >付款开票</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="supnote" label="8||supnote||供应商对账备注"
                >供应商对账备注</el-checkbox
              >
            </li>
          </ul>
        </el-checkbox-group>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button style="display:none;" type="danger" @click="doExportOrder('supplier')" :loadingsupplier="loadingsupplier">{{
          loadingsupplier ? "处理中 ..." : "按供应商导出"
        }}</el-button>
        <el-button type="danger" @click="doExportOrder()" :loading="loading">{{
          loading ? "处理中 ..." : "常规导出"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, onMounted, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { exportOrder, exportOrderSupplier, exportSaleOrder, exportSaleOrderSupplier, exportVerifyOrder,exportVerifyOrderSupplier } from "@/api/order";
// import util from "@/util/tool.js";

let timer;

const loading = ref(false);
const loadingsupplier = ref(false);

const emit = defineEmits(["click"]); // 声明父触发事件

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const exportFormRef = ref();
const exportForm = ref({
  header: [],
});

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: 10,
  platformed: "",
  platformnum: "",
  ordernum: "",
  name: "",
  customerid: "",
  supplierid: "",
  expressnum: "",
  receiver: "",
  receiverphone: "",
  maolivstatus: "",
  orderstatus: "",
  created: "",
  changed: "",
});

const exportOrderMethod = (obj) => {
  queryParam.value = obj;
  console.log(queryParam.value);
};

const exportActionVal = ref("order");
const exportAction = (v) => {
  exportActionVal.value = v;
};
defineExpose({ changeVisible, exportAction, exportOrderMethod });

const doExportOrder = (type) => {
  let headerTmp = [];
  let header = exportForm.value.header;
  header.forEach((item) => {
    let itemTmp = item.split("||");
    headerTmp.push({ index: itemTmp[0], name: itemTmp[1], value: itemTmp[2] });
  });
  exportFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    if (headerTmp.length <= 0) {
      ElMessage.error("请先选择要导出的字段！");
      return;
    }
    queryParam.value.pageSize = 5000;
    let data = {
      order: queryParam.value,
      header: headerTmp,
    };
    if (type) {
      exportActionVal.value = exportActionVal.value+'supplier';
    }

    if (exportActionVal.value == "order") {
      exportOrder(data).then((response) => {
        downloadExcel(response);
      });
    } else if (exportActionVal.value == "sale") {
      exportSaleOrder(data).then((response) => {
        downloadExcel(response);
      });
    } else if (exportActionVal.value == "verify") {
      exportVerifyOrder(data).then((response) => {
        downloadExcel(response);
      });
    } else if (exportActionVal.value == "ordersupplier") {
      exportOrderSupplier(data).then((response) => {
        downloadZip(response);
      });
    } else if (exportActionVal.value == "salesupplier") {
      exportSaleOrderSupplier(data).then((response) => {
        downloadZip(response);
      });
    } else if (exportActionVal.value == "verifysupplier") {
      exportVerifyOrderSupplier(data).then((response) => {
        downloadZip(response);
      });
    }
  });
};

const downloadExcel = (response) => {
  loading.value = true;
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loading.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
    exportForm.value.header = [];
    closeDialog();
    emit("click");
  }, 1000);
};

const downloadZip = (response) => {
  loadingsupplier.value = true;
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingsupplier.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/zip"
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
    exportForm.value.header = [];
    closeDialog();
    emit("click");
  }, 1000);
};

const closeDialog = () => {
  isvisible.value = false;
  exportFormRef.value.resetFields();
  clearTimeout(timer);
};

//onMounted方法
onMounted(() => {});
</script>
<style scoped>
.exportBox .el-dialog__body {
  padding-top: 0;
}
.exportBox .el-checkbox__label {
  font-weight: normal;
}
.exportBox div {
  max-height: 500px;
  overflow-y: auto;
}
.exportBox h1 {
  font-weight: normal;
  font-size: 18px;
  border-left: 2px solid #ff4849;
  border-radius: 2px;
  padding-left: 10px;
  line-height: 1;
}
.exportBox ul {
  padding: 0;
  margin: 0 0 35px 0;
  display: block;
}
.exportBox li {
  list-style: none;
  display: inline-block;
  width: 130px;
}
</style>